$(window).on('load', function () {
let interval = null
let domWorks = () => {
     let d = document.querySelector('.rec-slider .productgrid--item')
     if(d){
      slider();
      clearInterval(interval) // Change it via reference
     }
 }
interval = setInterval(domWorks, 100)
})


$(document).ready(function() {
    
    let interval = null
    let domWorks = () => {
       let d = document.querySelector('.rec-slider .productgrid--item')
       if(d){
       slider();
        clearInterval(interval) // Change it via reference
       }
    }
    interval = setInterval(domWorks, 100)

  var $slider = $('.featured-collections.best-seller-slider li');
  if ($slider.length > 4) {
  $('.featured-collections.best-seller-slider,.product-section--slider').slick({
    slidesToShow:4,
    slidesToScroll: 4,
    arrows: true,
    
    prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg class="" viewBox="0 0 100 100"><path d="M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z" class="arrow"></path></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg class="" viewBox="0 0 100 100"><path d="M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
    ]
  }); 
 }else{
    
    if($(window).width() < 767){
      
      $('.featured-collections.best-seller-slider,.product-section--slider').slick({
        slidesToShow:4,
        slidesToScroll: 4,
        arrows: true,
        
        prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg class="" viewBox="0 0 100 100"><path d="M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z" class="arrow"></path></svg></button>',
        nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg class="" viewBox="0 0 100 100"><path d="M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            }
          },
        ]
      });
    }
 }
  
  $('.productgrid--wrapper .js-load-more').on('click', function(){
   var $this =$(this),
   totalPages = parseInt($('[data-all-pages]').val()),
   currentPage = parseInt($('[data-this-page]').val()),
   datacollurl = $('[data-coll-url]').val();;
   $this.attr('disabled', true);
   $this.find('[load-more-text]').addClass('hide');
   $this.find('[loader]').removeClass('hide');
   var nextUrl = $('[data-next-link]').val();
   var current_page_new = currentPage + 1;
   var next_coll = currentPage + 2;
   //alert(current_page_new)
   //return false;
    console.log(nextUrl);
   $.ajax({
   url: nextUrl,
   type: 'GET',
   dataType: 'html',
   success: function(responseHTML){

     console.log($(responseHTML).find('.productgrid--items'));
     
     $('[data-next-link]').val(datacollurl + "?page="+next_coll);
     $('[data-this-page]').val(current_page_new);
     // $(responseHTML).find('.productgrid--item').each(function (index,element) {
     //   new ProductGridItem({
     //    el: element,
     //    id: element.closest('.shopify-section').querySelector('[data-section-data]').dataset.sectionId,
     //    lazy: false,
     //    grid_list: window.viewGrid || 'grid-view'
     //  });
     // });
     $('.productgrid--items').append($(responseHTML).find('.productgrid--items').html());
   },
   complete: function() {

      $(document).find('.productgrid--item').each(function (index,element) {
       $(element).find("figure img").removeAttr("srcset");
       $(element).find("figure [data-rimg-canvas]").addClass("visually-hidden");

       new ProductGridItem({
        el: element,
        id: element.closest('.shopify-section').querySelector('[data-section-data]').dataset.sectionId,
        lazy: false,
        grid_list: window.viewGrid || 'grid-view'
      });
     });
     
     if(current_page_new < totalPages) {
       $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
       } 
       if(current_page_new >= totalPages) {
         
       $this.find('[load-more-text]').text('Products Finished').removeClass('hide'); $this.find('[loader]').addClass('hide');
         $this.hide();
       } 
     }
   })
  });
  
// collection list item

$('.collection-list__container .js-load-more').on('click', function(){
   var $this =$(this),
   totalPages = parseInt($('[data-all-pages]').val()),
   currentPage = parseInt($('[data-this-page]').val()),
   datacollurl = $('[data-coll-url]').val();;
   $this.attr('disabled', true);
   $this.find('[load-more-text]').addClass('hide');
   $this.find('[loader]').removeClass('hide');
   var nextUrl = $('[data-next-link]').val();
   var current_page_new = currentPage + 1;
   var next_coll = currentPage + 2;
   //alert(current_page_new)
   //return false;
   $.ajax({
   url: nextUrl,
   type: 'GET',
   dataType: 'html',
   success: function(responseHTML){
     $('[data-next-link]').val(datacollurl + "?page="+next_coll);
     $('[data-this-page]').val(current_page_new);
     // $(responseHTML).find('.productgrid--item').each(function (index,element) {
     //   new ProductGridItem({
     //    el: element,
     //    id: element.closest('.shopify-section').querySelector('[data-section-data]').dataset.sectionId,
     //    lazy: false,
     //    grid_list: window.viewGrid || 'grid-view'
     //  });
     // });
     $('.collection-list__content').append($(responseHTML).find('.collection-list__content').html());
   },
   complete: function() {
  
      $(document).find('.collection__item').each(function (index,element) {
       $(element).find("figure img").removeAttr("srcset");
       $(element).find("figure [data-rimg-canvas]").addClass("visually-hidden");
  
      //  new ProductListItem({
      //   el: element,
      //   id: element.closest('.shopify-section').querySelector('[data-section-data]').dataset.sectionId,
      //   lazy: false,
      //   grid_list: window.viewGrid || 'grid-view'
      // });
     });
     
     if(current_page_new < totalPages) {
       $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
       } 
       if(current_page_new >= totalPages) {
         
       $this.find('[load-more-text]').text('Products Finished').removeClass('hide'); $this.find('[loader]').addClass('hide');
         $this.hide();
       } 
     }
   })
});  

  
$('.site-header-mobile-search-button, .site-header-desktop-search-button, .live-search--close').click(function(e){
  e.preventDefault();
  $('.live-search').toggleClass('active');
  setTimeout(function() {
  $('.live-search .form-field-input').focus();
  },500);
})
$('.live-search, .site-header-desktop-search-button').click(function(e){
  e.stopPropagation();
})
$('body').click(function(){
  $('.live-search').removeClass('active');
});

// $('.best-seller-slider').each(function(){
//   var slideHeight = $(this).find('.flickity-viewport').height() ;
//   $(this).find('.flickity-viewport').css('min-height', slideHeight+'px');
// })

  // $(window).resize(function(){
  //   $('.featured-collections.best-seller-slider').each(function(){
  //     var slideHeight = $(this).find('.flickity-viewport').height() ;
  //     $(this).find('.flickity-viewport').css('min-height', slideHeight+'px');
  //   })  
  // })

  
  
// Show the first tab and hide the rest

setTimeout(function() {
  $('#product-tabs li:first-child').addClass('active');
  $('.tab-content').hide();
  $('.tab-content:first').show();

},700)
  

// Click function

$('#product-tabs li').click(function(){
  $('#product-tabs li').removeClass('active');
  $(this).addClass('active');
  $('.tab-content').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).show();
  setTimeout(function() { })
   $('.featured-collections.best-seller-slider').slick('setPosition');
 
  // setTimeout(function() {
  //   $('.best-seller-slider').flickity('resize');  
  // },2000)
  
  return false;
});
  
  $(window).on('resize', function(){
    setTimeout(function() {
      if ($slider.length > 4) {
        $('.featured-collections.best-seller-slider,.product-section--slider').slick({
          slidesToShow:4,
          slidesToScroll: 4,
          arrows: true,
          
          prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg class="" viewBox="0 0 100 100"><path d="M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z" class="arrow"></path></svg></button>',
          nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg class="" viewBox="0 0 100 100"><path d="M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
          responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              }
            },
          ]
        }); 
       }else{
          
          if($(window).width() < 767){
            
            $('.featured-collections.best-seller-slider,.product-section--slider').slick({
              slidesToShow:4,
              slidesToScroll: 4,
              arrows: true,
              
              prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg class="" viewBox="0 0 100 100"><path d="M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z" class="arrow"></path></svg></button>',
              nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg class="" viewBox="0 0 100 100"><path d="M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
              responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                  }
                },
              ]
            });
          }
       }
    },1000)
    
  })

  $('.qty-box .qty-btn').on('click', function(){
    var qty = parseInt($(this).parent('.qty-box').find('.product-form__input').val());
    if($(this).hasClass('qty-plus')) {
      qty++;
    }else {
      if(qty > 1) {
        qty--;
      }
    }
    qty = (isNaN(qty))?1:qty;
    $(this).parent('.qty-box').find('.product-form__input').val(qty);
  }); 

  $(".load-more-div .load-more-btn").on("click", function(){
    var allCollLoaded = false;
    //console.log('window.gridToShow', window.gridToShow)
    if(window.gridToShow){
      let loopFromPosition = parseInt($(".collection-list__container ul li").last().data("item-position"));
      for(i = loopFromPosition + 1 ; i <= (loopFromPosition + window.gridToShow) ; i++ ){
        $(".collection-list__container ul").append(window.htmlDataToLoadJs[i]);
        if( i >=  window.totalGridsInBlock ){
          $('.load-more-btn [load-more-text]').empty().text("All Collections Loaded");
          $('.load-more-btn').addClass("visually-hidden");
          $('.load-more-btn').attr("disabled","disabled");
          $('.view_more_button').css("display","block")
          //console.log('window.totalGridsInBlock', window.totalGridsInBlock)
        }
      }
      $(".collection__iteminner").find("figure img").removeAttr("srcset");
      $(".collection__iteminner").find("figure [data-rimg-canvas]").fadeOut("fast");
    }
  })
   
   

})                  
$('.form-field-input').blur(function(){
    tmpval = $(this).val();
    if(tmpval == '') {
        $(this).addClass('empty');
        $(this).removeClass('form-field-filled');
    } else {
        $(this).addClass('form-field-filled');
        $(this).removeClass('empty');
    }
});


// if (window.location.pathname.indexOf('/products/') === -1) {
  $(() => {
    const checkDiv = setInterval(() => {
      if($('spark-product-card').length > 0){
        if(document.querySelector('spark-product-card').shadowRoot != null){
          if( document.querySelector('spark-product-card').shadowRoot.querySelector('.spark-product-card .product-price-wrapper') !== null) {    // it's better to use id instead of the class as selector
            //clearInterval(checkDiv);
            $('spark-product-card').each(function(i, obj) {
              if(obj.shadowRoot.querySelector('.spark-product-card .product-price-wrapper') !== null){
                obj.shadowRoot.querySelector('.spark-product-card .product-price-wrapper').setAttribute('style', 'display:none');
              }
              if(obj.shadowRoot.querySelector('.spark-product-card .product-variant-select') !== null){
                obj.shadowRoot.querySelector('.spark-product-card .product-variant-select').setAttribute('style', 'display:none');
              }
              if(obj.shadowRoot.querySelector('.spark-product-card .product-purchase-listing .product-quantity-wrap ') !== null){
                // obj.shadowRoot.querySelector('.spark-product-card .product-purchase-listing .product-quantity-wrap ').setAttribute('style', 'display:none');
                obj.shadowRoot.querySelector(".spark-product-card .product-purchase-listing .product-quantity-wrap").setAttribute('style', 'min-height:60px');
              }
              if( obj.shadowRoot.querySelector('.spark-product-card .product-purchase-listing .stock-status') !== null ){
                obj.shadowRoot.querySelector('.spark-product-card .product-purchase-listing .stock-status').setAttribute('style', 'display:none');
                var oosoo = obj.shadowRoot.querySelector('.spark-product-card .product-purchase-listing .stock-status span').innerHTML;
                if(oosoo.includes(window.sparkOptions.translations.en.pdp.messaging["back-order"]) || oosoo.includes(window.sparkOptions.translations.en["product-card"].messaging["back-order"]) ){
                  if(!$(this).closest("li").find(".product-stock-level-wrapper .product-stock-level__badge-text").hasClass("badgeUpdated")){
                    $(this).closest("li").find(".product-stock-level-wrapper .product-stock-level__badge-text").html(obj.shadowRoot.querySelector('.spark-product-card .product-purchase-listing .stock-status').innerHTML);
                    $(this).closest("li").find(".product-stock-level-wrapper .product-stock-level__badge-text").css("color","#0e00d4");
                    $(this).closest("li").find(".product-stock-level-wrapper .product-stock-level__badge-text").addClass("badgeUpdated");
                  }
                }
              }
            });
          }
        }
      }
    }, 100); // check after 100ms every time
  });
// }
 $(window).on("load resize scroll", function() {

    var highestBox = 0;
        $('.collection-list__content .collection__item-inner').each(function(){  
                if($(this).height() > highestBox){  
                highestBox = $(this).height();  
        }
    });    
    $('.collection-list__content .collection__item-inner').height(highestBox);


    //    var highestBox2 = 0;
    //     $('.collection-list__content .collection__iteminner .collection__item-title').each(function(){  
    //             if($(this).height() > highestBox2){  
    //             highestBox2 = $(this).height();  
    //     }
    // });    
    // $('.collection-list__content .collection__iteminner .collection__item-title').height(highestBox2);

   setTimeout(function(){
       $(".template-product .productgrid--item .productitem__container").each(function() {
        $(".template-product .productgrid--item .productitem__container").css("min-height", "1px");
        var e = -1;
        $(".template-product .productgrid--item .productitem__container").each(function() {
          var t = $(this).outerHeight();
          e = t > e ? t : e
        }), $(".template-product .productgrid--item .productitem__container").css("min-height", e)
      })  
   },1000)

});

/* Hide default searchbar when width is less than 768 - Start */

let checkSizeAndHideSearchBarOnMobile = function(){
console.log("Function Called !!")
  if(window.outerWidth < 768){
      document.querySelector(".live-search").classList.add("visually-hidden")
  }
  else{
    document.querySelector(".live-search").classList.remove("visually-hidden")
  }
} 
window.addEventListener('resize',checkSizeAndHideSearchBarOnMobile, true);
window.addEventListener('load',checkSizeAndHideSearchBarOnMobile, true);

/* Hide default searchbar when width is less than 768 - End */

function slider(){
  if(!($('.rec-slider').hasClass('slick-initialized')) ){  
  $('.rec-slider').slick({
    slidesToShow:4,
    slidesToScroll: 4,
    arrows: true,
    prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg class="" viewBox="0 0 100 100"><path d="M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z" class="arrow"></path></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg class="" viewBox="0 0 100 100"><path d="M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
    ]
  });
 }
}


// login modal js
$(document).ready(function(){
  $('.register-flyout-box .button-primary').on('click', function(e){
    $('.register-flyout').removeClass('on');  
  });
  $('.site-header-right .site-header_account-link-anchor, .promo-mosaic--section a[href="/account"],  .register-flyout-box .button-primary, .login-price-text').on('click', function(e){
    e.preventDefault();
    $('.login-modal').addClass('modal-open');
  });
  $('.login-modal .lm-wrapper').on('click', function(e){
    e.stopPropagation()
  })
  $('.login-modal, .login-modal .lm-close').on('click', function(e){
    e.preventDefault();
    $('.login-modal').removeClass('modal-open');
  })
  $('.login-modal #customer_recovery .button-secondary').on('click', function(){
      $('.login-modal #customer_recovery').removeClass('visible');
      $('.login-modal .account-login').addClass('visible');
  })
  
  $('.login-modal .forgot-link a').on('click', function(e){
      e.preventDefault();
      $('.login-modal #customer_recovery').addClass('visible');
      $('.login-modal .account-login').removeClass('visible');
  })

  $('.register-flyout .rf-close').on('click', function(e){
    $('.register-flyout').removeClass('on');
    setCookie('flyout','yes',1);  
  })

  if(getCookie('flyout') == 'yes'){
    $('.register-flyout').removeClass('on');
  }else{
    $('.register-flyout').addClass('on');
  }
})

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}